/**
 * Generate a unique id. Uses crypto.randomUUID() when available (not in all Wear OS WebViews).
 */
export function safeId() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID()
  }
  return 'id-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 11)
}
